import moment from "moment";
import {
  campoVisivel,
  getNovaAbaPadrao,
  sistemasSelecionadosDoLocal,
} from "./bannerLabels";

export function defaultBanner() {
  return {
    id: null,
    nome: "",
    imagem_desktop: "",
    imagem_mobile: "",
    data_inicio: "",
    data_fim: "",
    tipo: "LINK_EXTERNO",
    nova_aba: getNovaAbaPadrao("LINK_EXTERNO"),
    popup: false,
    ordem: "1",
    local: "HOME",
    href: "",
    filiais: [],
    sistemas: [],
    link_integrado_id: null,
    link_integrado_descricao: "",
  };
}

export function cloneBannerParaCriacao(banner) {
  return {
    ...banner,
    id: null,
    nome: `Cópia de ${banner.nome}`,
    filiais: banner.filiais ? [...banner.filiais] : [],
    sistemas: banner.sistemas ? [...banner.sistemas] : [],
  };
}

export function normalizeBannerParaApi(item, sistemas) {
  const normalized = { ...item };

  normalized.data_inicio = item.data_inicio
    ? moment(item.data_inicio).format("YYYY-MM-DD")
    : null;
  normalized.data_fim = item.data_fim
    ? moment(item.data_fim).format("YYYY-MM-DD")
    : null;
  normalized.popup = campoVisivel(item.local, "popup") ? item.popup : false;

  if (sistemas) {
    normalized.sistemas = sistemasSelecionadosDoLocal(item.local, item.sistemas, sistemas);
  }

  return normalized;
}

/**
 * Zera o que o local escolhido não usa, para não persistir destino/imagem de um
 * layout que a tela nem exibe.
 */
export function limparCamposNaoUsados(item) {
  item.href = null;
  item.imagem_mobile = null;
  item.link_integrado_id = null;
  item.link_integrado_descricao = "";
}
